import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card, CardSubmitEvent, CardSubmitParsedValue } from '@/shared/components/cardRenderer';
import { InstalledApp, AppConfigViewModel } from '@/features/apps/shared/models';
import Toast from '@/shared/services/toast';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { ConfigRequest } from './configRequest';
import { AppCard } from '@/features/apps/shared/models/appCard';
import { computed, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'CapableAppConfig',
  props: {
  installedApp: {
    type: Object as PropType<InstalledApp>,
    required: true,
  },
  configRequest: {
    type: Function as PropType<
      (workspaceId: string, installedAppId: string, values: any, storedData: any, componentId: any) => Promise<any>
    >,
    required: true,
  },
},
  emits: ["configured"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const card = ref<AppCard>({
  components: [],
});
const loading = ref(true);

onMounted(() => appConfig(props.installedApp.installedAppId));

function getCards(): Card[] {
  return [
    {
      id: 'appConfig',
      content: card.value,
    },
  ];
}

function cardSubmit(e: CardSubmitEvent) {
  appConfig(props.installedApp.installedAppId, e.parsedValues, e.componentId);
}

const emit = __emit;

async function appConfig(installedAppId: string, values?: CardSubmitParsedValue[], componentId?: string) {
  try {
    const res: AppConfigViewModel = await props.configRequest(
      currentWorkspace.value.id,
      installedAppId,
      getInputData(values),
      storedData.value,
      componentId,
    );
    if (res.card && res.card.components) {
      // more UI to render
      card.value = res.card;
      loading.value = false;
    } else {
      // config endpoint has created a new configuration
      Toast.showSuccess('Configured app');
      emit('configured', installedAppId, res.config);
    }
  } catch (error: any) {
    Toast.showError(error.message);
    if (!card.value) {
      card.value = {
        components: [],
      };
    }
    loading.value = false;
  }
}

function getInputData(submittedValues?: CardSubmitParsedValue[]): { [key: string]: string } {
  const values: { [key: string]: string } = {};
  if (submittedValues) {
    for (const value of submittedValues) {
      values[value.id] = value.value;
    }
  }
  return values;
}

const storedData = computed(() => {
  if (card.value.storedData) {
    return card.value.storedData;
  }
  return {};
});

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createBlock(CardRenderer, {
          key: 1,
          colour: '#062B80',
          location: 'embedded',
          cards: getCards(),
          onSubmit: _cache[0] || (_cache[0] = ($event: any) => (cardSubmit($event)))
        }, null, 8, ["cards"]))
      : _createCommentVNode("", true)
  ]))
}
}

})